import React, { FC, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { Loader } from "@epcnetwork/core-ui-kit";

import { resetUserStore } from "store";
import { TOKEN_STORAGE_FIELD, REFRESH_TOKEN_STORAGE_FIELD } from "constants/auth.constants";
import { LOGIN_PAGE } from "constants/routes.constants";

const Logout: FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    // remove tokens
    localStorage.removeItem(TOKEN_STORAGE_FIELD);
    localStorage.removeItem(REFRESH_TOKEN_STORAGE_FIELD);

    // reset redux
    dispatch(resetUserStore());

    // redirect to login
    history.push(LOGIN_PAGE.path);
  }, [dispatch, history]);

  return <Loader />;
};

export default Logout;
